import { type CreateMileageRatePresetInputData } from '../../business-logic/types'
import { type MileageRatePresetPayload } from '../types/MileageRatePresetPayload'

export const mapCreateMileageRatePresetInputDataToApi = (
  input: CreateMileageRatePresetInputData
): MileageRatePresetPayload => {
  // Optional inputs may be omitted (undefined) or explicitly null; normalize
  // to null up front so the pairing check below can compare strictly.
  const advisoryFuelRate = input.advisoryFuelRate ?? null
  const taxId = input.taxId ?? null

  // The BE WriteSerializer requires advisory_fuel_rate and tax_id to be
  // supplied together — both set or both omitted (ExpenseMileagePreset
  // WriteSerializer.validate). Fail fast on the client instead of round-
  // tripping to a 400.
  if ((advisoryFuelRate === null) !== (taxId === null)) {
    throw new Error('advisoryFuelRate and taxId must be set together')
  }

  return {
    name: input.name,
    rate: String(input.rate),
    currency_id: input.currencyId,
    unit: input.unit,
    advisory_fuel_rate:
      advisoryFuelRate === null ? null : String(advisoryFuelRate),
    tax_id: taxId,
  }
}
